module.exports = __webpack_public_path__ + "img/invite-members-btn.ea6a2e73.png";